import React from 'react';
import { Paper } from '@mui/material';

function TopAreaSpace({
  component: Component = Paper,
  ...props
}) {
  return (
    <Component
      sx={{
        height: 'var(--gap-top)',
      }}
      {...props}
      elevation={0}
    />
  );
}

export default TopAreaSpace;
